import { Alert, Slide, Snackbar } from "@mui/material";
import { useContext } from "react";
import UIContext from "../../context/UIContext";

const SnackBar = () => {
  const { alertOpen, alertMessage, alertType, alertPersistent, closeSnackBar } = useContext(UIContext);

  const handleClose = (_, reason) => {
    // Keep snackbar open when user clicks elsewhere on the page.
    if (reason === 'clickaway') return;
    closeSnackBar();
  };

  return (
    <Snackbar
      style={{ marginTop: '45px' }}
      open={alertOpen}
      autoHideDuration={alertPersistent ? null : 3000} // No auto-hide for persistent
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={(props) => <Slide {...props} direction="right" />}
    >
      <Alert onClose={closeSnackBar} severity={alertType || 'success'} variant="filled" sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;